export type SlotState = 'generado' | 'impreso' | 'en_custodia' | 'activado' | 'suspendido' | 'dado_de_baja';

export interface Slot {
  id: string;
  code: string;
  domain: string;
  shortUrl: string;
  kind?: 'physical' | 'digital' | 'legacy';
  state?: SlotState;
  orgId?: string;
  lotId?: string | null;
  custodianUid?: string | null;
  activatedBy?: string | null;
  activatedAt?: string | null;
  targetUrl?: string | null;
  destStatus?: 'ok' | 'pending' | 'flagged' | null;
  business?: { name: string | null; externalRef: string | null } | null;
}

export interface SlotList {
  items: Slot[];
  total: number;
  nextCursor: number | null;
}

export interface ActivatedSlot extends Slot {
  piiNotice?: { replaced: string[]; message: string };
}

export const PRIMARY_DOMAIN = 'q-r.cl';

/** `?domain=` solo para dominios secundarios; q-r.cl es el valor por defecto de la API. */
export function domainQuery(domain: string | null | undefined): string {
  return domain && domain !== PRIMARY_DOMAIN ? `?domain=${encodeURIComponent(domain)}` : '';
}
